<ng-template #referenceModal let-c="close" let-d="dismiss">
  <form #referenceForm="ngForm" [class.submitted]="referenceForm.submitted"
        (ngSubmit)="processForm(referenceForm)" novalidate>
    <!--Header-->
    <div class="modal-header">
      <h4 class="modal-title">Add Object References and Tags</h4>
      <button type="button" class="btn btn-close" id="closeReferenceModalBtn" aria-label="Close" (click)="d()"></button>
    </div>

    <!--Body-->
    <div class="modal-body">
      <div class="references">
        <div class="">
        </div>
        <!--companyRef-->
        <div class="row">
          <div class="col-4">
            <strong class="text-uppercase">Reference Type</strong>
            <input class="form-control reference-types" type="text" readonly [value]="companyRef.name">
          </div>
          <div class="col-8">
            <strong class="text-uppercase">Reference Values</strong>
            <ng-select [items]="companyRef.options"
                      [(ngModel)]="companyRef.referencesIds"
                      bindLabel="referencedLabel"
                      bindValue="referencedId"
                      [multiple]="true"
                      [hideSelected]="true"
                      [addTag]="false"
                      [clearable]="false"
                      [typeahead]="referenceTypeahead"
                      (focus)="selectAutocompleteEntity(companyRef)"
                      (add)="onAddRef($event, companyRef)"
                      (remove)="onRemoveRef($event, companyRef)"
                      name="companyReferenceValues"
                      id="{{'companyRefValues'}}">
            </ng-select>
          </div>
        </div>

        <!--indicationRef-->
        <div class="row">
          <div class="col-4">
            <strong class="text-uppercase">Reference Type</strong>
            <input class="form-control reference-types" type="text" readonly [value]="indicationRef.name">
          </div>
          <div class="col-8">
            <strong class="text-uppercase">Reference Values</strong>
            <ng-select [items]="indicationRef.options"
                      [(ngModel)]="indicationRef.referencesIds"
                      bindLabel="referencedLabel"
                      bindValue="referencedId"
                      [multiple]="true"
                      [hideSelected]="true"
                      [addTag]="false"
                      [typeahead]="referenceTypeahead"
                      [clearable]="false"
                      (focus)="selectAutocompleteEntity(indicationRef)"
                      (add)="onAddRef($event, indicationRef)"
                      (remove)="onRemoveRef($event, indicationRef)"
                      name="indicationReferenceValues"
                      id="{{'indicationRefValues'}}">
            </ng-select>
          </div>
        </div>

        <!--productRef-->
        <div class="row">
          <div class="col-4">
            <strong class="text-uppercase">Reference Type</strong>
            <input class="form-control reference-types" type="text" readonly [value]="productRef.name">
          </div>
          <div class="col-8">
            <strong class="text-uppercase">Reference Values</strong>
            <ng-select [items]="productRef.options"
                      [(ngModel)]="productRef.referencesIds"
                      bindLabel="referencedLabel"
                      bindValue="referencedId"
                      [multiple]="true"
                      [hideSelected]="true"
                      [addTag]="false"
                      [typeahead]="referenceTypeahead"
                      [clearable]="false"
                      (focus)="selectAutocompleteEntity(productRef)"
                      (add)="onAddRef($event, productRef)"
                      (remove)="onRemoveRef($event, productRef)"
                      name="productReferenceValues"
                      id="{{'productRefValues'}}">
            </ng-select>
          </div>
        </div>

        <!--conferenceRef-->
        <div class="row">
          <div class="col-4">
            <strong class="text-uppercase">Reference Type</strong>
            <input class="form-control reference-types" type="text" readonly [value]="conferenceRef.name">
          </div>
          <div class="col-8">
            <strong class="text-uppercase">Reference Values</strong>
            <ng-select [items]="conferenceRef.options"
                      [(ngModel)]="conferenceRef.referencesIds"
                      bindLabel="referencedLabel"
                      bindValue="referencedId"
                      [multiple]="true"
                      [hideSelected]="true"
                      [addTag]="false"
                      [typeahead]="referenceTypeahead"
                      [clearable]="false"
                      (focus)="selectAutocompleteEntity(conferenceRef)"
                      (add)="onAddRef($event, conferenceRef)"
                      (remove)="onRemoveRef($event, conferenceRef)"
                      name="conferenceReferenceValues"
                      id="{{'conferenceRefValues'}}">
            </ng-select>
          </div>
        </div>
      </div>
      <div class="tags">
        <div class="">
          <div ngbDropdown name="tagSelector" id="tagSelector" class="d-inline-block" container="body">
            <div class="btn btn-outline-primary mr-2" ngbDropdownToggle>Tags</div>
            <div ngbDropdownMenu class="dropdown-menu">
              <label class="w-100 mx-1 d-flex justify-content-start align-items-center" *ngFor="let tag of allTags">
                <input (change)="updateModifiedTags(tag)" type="checkbox" class="mx-1" name="{{tag.text}}" [checked]="isTagAttached(tag.id)">
                {{tag.text}}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Footer-->
    <div class="modal-footer">
      <button type="button" class="btn btn-default mr-3" (click)="c()">{{"GENERICS.CANCEL" | translate}}</button>
      <button type="submit" class="btn btn-primary">{{"GENERICS.SAVE" | translate}}</button>
    </div>
  </form>

</ng-template>
